module.exports = __webpack_public_path__ + "img/team_leader_2.5c0042da.png";